module.exports = __webpack_public_path__ + "packs/media/images/unprocessed-df71ea0e4310fa450fe47e19a0efa2f7.jpg";